var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99992 1.33317L7.18133 5.36316C7.66281 5.73764 8.33703 5.73764 8.81851 5.36316L13.9999 1.33317M3.46659 11.3332H12.5333C13.28 11.3332 13.6534 11.3332 13.9386 11.1878C14.1895 11.06 14.3934 10.856 14.5213 10.6052C14.6666 10.3199 14.6666 9.94657 14.6666 9.19984V2.79984C14.6666 2.0531 14.6666 1.67973 14.5213 1.39452C14.3934 1.14363 14.1895 0.93966 13.9386 0.811829C13.6534 0.666504 13.28 0.666504 12.5333 0.666504H3.46659C2.71985 0.666504 2.34648 0.666504 2.06126 0.811829C1.81038 0.93966 1.60641 1.14363 1.47858 1.39452C1.33325 1.67973 1.33325 2.0531 1.33325 2.79984V9.19984C1.33325 9.94657 1.33325 10.3199 1.47858 10.6052C1.60641 10.856 1.81038 11.06 2.06126 11.1878C2.34648 11.3332 2.71985 11.3332 3.46659 11.3332Z",
    stroke: "#000536",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.f4e49764e92c32bcdab900785936ae0e.svg";
export { ForwardRef as ReactComponent };